import { actionProps } from "@/lib/controlAnalytics";
import { Link } from "react-router-dom";
import type { Posting } from "@/lib/api/catalogue";
import { companyOf, companyPath } from "@/lib/jobs/company";
import { ROUTES } from "@/lib/routes";

/** Jobs, then History once applied or the company's jobs before, then the posting. */
export default function PostingBreadcrumb({
    posting,
    applied,
}: {
    posting: Posting;
    applied: boolean;
}) {
    return (
        <nav
            aria-label="Breadcrumb"
            className="flex min-w-0 items-center gap-1.5 whitespace-nowrap text-ui text-fg-muted"
        >
            <Link
                {...actionProps("navigation_clicked", {
                    source: "PostingDetail",
                    target: ROUTES.HOME,
                })}
                to={ROUTES.HOME}
                className="shrink-0 font-medium hover:text-brand-ink"
            >
                Jobs
            </Link>
            <span className="shrink-0 text-fg-faint">/</span>
            {applied ? (
                <Link
                    {...actionProps("navigation_clicked", {
                        source: "PostingDetail",
                        target: ROUTES.HISTORY,
                    })}
                    to={ROUTES.HISTORY}
                    className="shrink-0 font-medium hover:text-brand-ink"
                >
                    History
                </Link>
            ) : (
                <Link
                    {...actionProps("posting_company_search_clicked", {
                        source: "PostingDetail",
                        posting_id: posting.posting_id,
                    })}
                    to={companyPath(companyOf(posting))}
                    className="flex min-w-0 font-medium hover:text-brand-ink"
                >
                    {/* Cut inside the link, so its phone reach is not clipped with it. */}
                    <span className="truncate">{posting.company}</span>
                </Link>
            )}
            <span className="shrink-0 text-fg-faint">/</span>
            <span aria-current="page" className="min-w-0 truncate text-fg">
                {posting.title}
            </span>
        </nav>
    );
}
